// src/components/Pages/AmlKyc.jsx  →  /aml
import React from 'react';
import { Link } from 'react-router-dom';
import { FiUserCheck, FiShield, FiLock, FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { useAuthGate } from '../../Context/AuthGateContext';
import PhaseRoadmap from './PhaseRoadmap';
import './InfoPages.css';

const LEVELS = [
  { n: 0, name: 'Registrado', need: 'Email, usuario y contraseña', unlock: 'Explorar el marketplace y el portafolio de ejemplo', status: 'is-active' },
  { n: 1, name: 'Básico',     need: 'Teléfono, nombre legal y país', unlock: 'Comprar montos bajos', status: 'is-active' },
  { n: 2, name: 'Identidad',  need: 'Documento + selfie (proveedor KYC)', unlock: 'Vender ofertas y límites más altos', status: 'is-soon' },
  { n: 3, name: 'Avanzado',   need: 'Comprobante de domicilio / origen de fondos', unlock: 'Alto volumen / market maker', status: 'is-planned' },
];

const PHASES = [
  { kicker: 'Fase 0 · Ahora', status: 'active', title: 'MVP — Recolección básica',
    desc: 'Hoy pedimos lo mínimo para empezar.',
    items: ['Datos básicos en el registro (incluye teléfono)', 'Estructura de niveles ya preparada en el sistema'] },
  { kicker: 'Fase 1 · En curso', status: 'progress', title: 'Verificación Nivel 1',
    items: ['Verificación de email', 'OTP por teléfono', 'Habilita compras de monto bajo'] },
  { kicker: 'Fase 2 · Próximamente', status: 'soon', title: 'Identidad Nivel 2 (KYC documental)',
    items: ['Documento + selfie con proveedor certificado', 'Screening AML y listas de sanciones', 'Habilita vender y límites altos'] },
  { kicker: 'Fase 3 · Planeado', status: 'planned', title: 'Diligencia avanzada Nivel 3',
    items: ['Comprobante de domicilio / origen de fondos', 'Monitoreo continuo de operaciones'] },
];

export default function AmlKyc() {
  const { openAuth } = useAuthGate();
  return (
    <div className="ip-wrap">
      <Link to="/" className="ip-back"><FiArrowLeft /> Volver al marketplace</Link>

      <div className="ip-hero">
        <span className="ip-eyebrow"><FiUserCheck /> Política AML / KYC</span>
        <h1 className="ip-title">Verificación por niveles</h1>
        <p className="ip-sub">Como toda plataforma financiera responsable, verificamos identidad para prevenir fraude y lavado de activos — pero de forma progresiva: solo te pedimos lo necesario para lo que querés hacer.</p>
        <span className="ip-phase-badge"><span className="ip-live-dot" /> MVP: recolección básica activa</span>
      </div>

      <section className="ip-section">
        <h2 className="ip-section-title"><FiShield /> Niveles de cuenta</h2>
        <div className="ip-levels">
          {LEVELS.map((l) => (
            <div key={l.n} className={`ip-level ${l.status}`}>
              <div className="ip-level-top">
                <span className="ip-level-num">NIVEL {l.n}</span>
              </div>
              <h3 className="ip-level-name">{l.name}</h3>
              <div className="ip-level-row"><span className="ip-level-k">Qué pedimos</span><span className="ip-level-v">{l.need}</span></div>
              <div className="ip-level-row"><span className="ip-level-k">Qué desbloquea</span><span className="ip-level-v">{l.unlock}</span></div>
            </div>
          ))}
        </div>
        <p className="ip-levels-foot"><FiUserCheck className="ip-levels-foot-ic" /> Hoy, <strong>vender se habilita por invitación</strong> (nuestra base de comerciantes verificados). Cuando se active el Nivel 2, la verificación de identidad reemplazará a la invitación.</p>
      </section>

      <section className="ip-section">
        <h2 className="ip-section-title"><FiUserCheck /> Cómo lo vamos activando</h2>
        <PhaseRoadmap phases={PHASES} />
      </section>

      <div className="ip-note">
        <span className="ip-note-ic"><FiLock /></span>
        <p><strong>Tu privacidad primero.</strong> Recolectamos los datos mínimos y los ciframos. Los documentos de identidad se procesan con un proveedor especializado y <strong>no se almacenan en nuestra base de datos</strong>: solo guardamos el estado de la verificación. Podés pedir la eliminación de tus datos según la normativa aplicable.</p>
      </div>

      <div className="ip-cta">
        <h3>Empezá en segundos</h3>
        <p>Creá tu cuenta hoy (Nivel 0) y subí de nivel cuando lo necesites.</p>
        <button className="ip-cta-btn" onClick={() => openAuth('register')}>Crear mi cuenta <FiArrowRight /></button>
      </div>
    </div>
  );
}
